import "./FAQ.css";
import { useTranslation } from "react-i18next";
import FadeInSection from "../FadeInSection/FadeInSection";

const FAQ = () => {
  const { t } = useTranslation();

  const datosTarjeta = t("faq.items", { returnObjects: true });
  return (
    <FadeInSection>
      <div className="faqMS">
        <div className="faqfondoMS">
          <span className="tituloFaqMS">{t("faq.title")}</span>
          <div className="preguntasMS">
            {datosTarjeta.map((item) => (
              <div key={item.id} className="preguntaMS">
                <div className="iconoFaqMS">
                  <img
                    src={`./img/preguntasFrecuentes/${item.imagen}`}
                    alt=""
                  />
                </div>
                <div className="textoFaqMS">
                  <span className="pregMS">{item.pregunta}</span>
                  <span className="respMS">{item.respuesta}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </FadeInSection>
  );
};

export default FAQ;
